import React from "react";
import { Table } from "antd";

import "antd/dist/antd.css";
import "./styles.css";

const CustomTable = ({
  columns,
  data,
  loading,
  handleTableChange,
  pagination,
  scrollX,
  summary,
  onRow,
}) => {
  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        id="custom-table"
        loading={loading}
        onChange={handleTableChange}
        pagination={pagination}
        scroll={{ x: scrollX }}
        summary={summary}
        onRow={onRow}
      />
    </>
  );
};

export default CustomTable;
